import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

import { Text, Box } from '../components/Boneyard';

const propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  backgroundColor: PropTypes.string,
};

const InfoIcon = ({
  width = 15,
  height = 15,
  backgroundColor,
  theme,
  ...props
}) => (
  <Box
    d="flex"
    alignItems="center"
    justifyContent="center"
    h={height + 'px'}
    w={width + 'px'}
    backgroundColor={backgroundColor || theme.colors.common.peacockBlue}
    borderRadius={8}
    {...props}
  >
    <Text size={15} color={'white'} weight={700}>
      i
    </Text>
  </Box>
);
InfoIcon.propTypes = propTypes;

export default withTheme(InfoIcon);
